import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  OFFLINE_ENABLED_MODULES,
  OFFLINE_MODULE_POLICY,
  OfflineModulePolicy,
} from '@shared/constants/offline-module-policy.constants';
import {
  OFFLINE_ENDPOINT_POLICIES,
  OfflineEndpointKey,
  OfflineEndpointPolicyEntry,
} from '@shared/constants/offline-endpoint-policy.constants';
import { OfflineEndpointPolicyType } from '@shared/constants/offline.constants';

@Injectable({ providedIn: 'root' })
export class OfflinePolicyService {
  isOfflineModeEnabled(): boolean {
    return environment.OFFLINE_MODE_ENABLED === true;
  }

  getModulePolicy(moduleKey: string): OfflineModulePolicy | undefined {
    return OFFLINE_MODULE_POLICY[moduleKey];
  }

  isModuleEnabled(moduleKey: string): boolean {
    if (!this.isOfflineModeEnabled()) {
      return false;
    }
    return OFFLINE_MODULE_POLICY[moduleKey]?.enabled === true;
  }

  getEnabledModules(): string[] {
    if (!this.isOfflineModeEnabled()) {
      return [];
    }
    return OFFLINE_ENABLED_MODULES;
  }

  resolveEndpointPolicy(url: string | null): OfflineEndpointPolicyEntry | undefined {
    if (!url || !this.isOfflineModeEnabled()) {
      return undefined;
    }

    return OFFLINE_ENDPOINT_POLICIES.find((entry) => url.includes(this.stripBaseUrl(entry.url)));
  }

  getEndpointPolicyType(key: OfflineEndpointKey): OfflineEndpointPolicyType {
    return OFFLINE_ENDPOINT_POLICIES.find((entry) => entry.key === key)?.policy ?? 'network-only';
  }

  private stripBaseUrl(fullUrl: string): string {
    const base = environment.BASE_API_URL ?? '';
    return fullUrl.startsWith(base) ? fullUrl.slice(base.length) : fullUrl;
  }
}
